import React, { useEffect, useState } from 'react';
import '../ChartsDashboard.css';
import { Col, Row } from 'react-bootstrap';
import * as chartjs from 'chart.js';
import ChartJSDataLabels from 'chartjs-plugin-datalabels';
import moment from 'moment';
import { Bar } from 'react-chartjs-2';
// import { Bar } from 'react-chartjs-2';

chartjs.Chart.register(ChartJSDataLabels);

interface Props {
  cumulativeSales: {
    date: string,
    totalUSD: number,
    totalEUR: number,
    total: number
  }[];
  nMonths: number;
}

const ChartSalesPastNMonths = ({ cumulativeSales, nMonths }: Props) => {
  const monthsInYear = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
  const currMonth = moment().month();
  const currYear = moment().year();

  const [months, setMonths] = useState<{ label: string, index: number, data: { totalEUR: number, totalUSD: number } }[]>([]);

  const getPastSixMonth = () => {
    const pastMonth = currMonth - nMonths + 1;
    const limitMonthIndex = 12 + pastMonth;
    const pastMonths = monthsInYear.filter((y) => y >= limitMonthIndex).map(y => ({
      label: moment(new Date(currYear - 1, y)).format('MMM'),
      id: moment(new Date(currYear - 1, y)).format('YYYY-MMM'),
      index: y,
      data: {
        totalEUR: 0,
        totalUSD: 0
      }
    }));
    const currentMonths = monthsInYear.filter((y) => y <= currMonth).map(y => ({
      label: moment(new Date(currYear, y)).format('MMM'),
      id: moment(new Date(currYear, y)).format('YYYY-MMM'),
      index: y,
      data: {
        totalEUR: 0,
        totalUSD: 0
      }
    }));
    return [...pastMonths, ...currentMonths];
  };

  useEffect(() => {
    const data = getPastSixMonth();
    // console.log(data);
    if (cumulativeSales) {
      data.forEach(m => {
        const cumulativeForMonth = cumulativeSales.filter(cs => moment(cs.date).format('YYYY-MMM') === m.id);
        const totalUSD = cumulativeForMonth.map(c => c.totalUSD).reduce((a, b) => a + (b || 0), 0);
        const totalEUR = cumulativeForMonth.map(c => c.totalEUR).reduce((a, b) => a + (b || 0), 0);
        m.data = {
          totalUSD,
          totalEUR
        };
      });
      setMonths(data);
    }
  }, []);
  const io = ' €';
  const us = ' $';

  const options = {
    plugins: {
      datalabels: {
        display: true,
        color: 'transparent',
        formatter: (value: any, ctx: any) => {
          if (ctx.dataset.label === '.io') {
            return `${Math.round(months[ctx.dataIndex].data?.totalEUR * 100) / 100} ${io}`;
          } else {
            return `${Math.round(months[ctx.dataIndex].data?.totalUSD * 100) / 100} ${us}`;
          }
        }
      }
    },
    legend: {
      display: true,
      font: {
        weight: 'bold',
        size: 16
      }
    }
  };

  return (
    <>
      <Row>
        <Col>
          <div  >{cumulativeSales && months ? <Bar data={{
            labels: months.map(m => m.label),
            datasets: [
              {
                label: '.io',
                data: months.map(m => m.data?.totalEUR || 0),
                backgroundColor: 'rgb(54, 162, 235)'
              },
              {
                label: '.us',
                data: months.map(m => m.data?.totalUSD || 0),
                backgroundColor: 'rgb(75, 192, 192)'
              }
            ]
          }
          } options={options} /> : <p></p>}
          </div>
        </Col>
      </Row>
    </>
  );
};

export default ChartSalesPastNMonths;
/* eslint-enable i18next/no-literal-string */
